export default "/images/MDLinx.jpg?cff190828481148adeed7045f0d7482c";